import { useAtom } from 'jotai';
import { useEffect } from 'react';
import { highlightedFieldAtom } from '~/atoms/document/documentOverviewAtoms';
import { Route as FundRoute } from '~/routes/_authLayout/documents.fund.$fundId';
import { Route as PortfolioRoute } from '~/routes/_authLayout/portfolio-company.$portfolioId';

/**
 * Uses the location hash to store highlight ID.
 *
 * todo: known bug in the document viewer where
 *       scrolling on load doesn't work.
 **/
export function useScrolledHighlight(source = 'fundDocuments') {
  // const navigate = useNavigate();
  // const location = useLocation();
  // const scrolledHighlight = location.hash.substring(1);
  const { x2, y2 } =
    source === 'fundDocuments'
      ? FundRoute.useSearch()
      : PortfolioRoute.useSearch();
  const [scrolledHighlight, setScrolledHighlight] =
    useAtom(highlightedFieldAtom);

  useEffect(() => {
    if (x2 && y2) {
      console.log('scrolling to highlight', x2, y2);
      // setScrolledHighlight(bbox_page_start);
    }
  }, [x2, y2]);
  const scrollToHighlight = (id: string) => {
    setScrolledHighlight(id);
    // navigate({to: `#${id}`});
  };
  // useLocationHash(scrolledHighlight, scrollToHighlight);
  return { scrolledHighlight, scrollToHighlight };
}
